import { IPedAppearanceValue } from './appearance';
import { Job } from './jobs';

export interface IPlayerCharacter {
	id: string;
	name: string;
	level: number;
	totalMoneyAmount: number;
	lastEnteredAt: number | null;
	/** number если временный бан, null если вечный */
	banExpiresAt?: number | null;
	banReason?: string | null;

	appearance: IPedAppearanceValue | null;
	clothes: string[] | null;
	tattoos: string[] | null;
}

export type PlayerCharacterPreview = Pick<IPlayerCharacter, 'appearance' | 'clothes' | 'tattoos'> | null;

export enum CharacterSkill {
	// Работы
	JOB_FARMER = 'job_farmer',
	JOB_TAXI = 'job_taxi',
	JOB_COURIER = 'job_courier',
	JOB_BUS = 'job_bus',
	JOB_PIZZA_DELIVERY = 'job_pizza_delivery',
	JOB_ELECTRICIAN = 'job_electrician',
	JOB_POST = 'job_post',

	// Хобби
	HOBBY_FISHING = 'hobby_fishing',
	// Остальное
}

export const characterSkillByJob: Record<Job, CharacterSkill> = {
	[Job.Farmer]: CharacterSkill.JOB_FARMER,
	[Job.Taxi]: CharacterSkill.JOB_TAXI,
	[Job.Courier]: CharacterSkill.JOB_COURIER,
	[Job.Bus]: CharacterSkill.JOB_BUS,
	[Job.PizzaDelivery]: CharacterSkill.JOB_PIZZA_DELIVERY,
	[Job.Electrician]: CharacterSkill.JOB_ELECTRICIAN,
	[Job.Post]: CharacterSkill.JOB_POST,
};

export interface IPlayerLevel {
	exp: number; // количество опыта игрока
	nextLevelExp: number; // количество опыта, необходимого для перехода на следующий уровень
	level: number; // текущий уровень игрока
	levelProgress: number; // прогресс текущего уровня
}

export interface IPlayerJailInfo {
	expiresAt: number | null;
	reason: string;
}

export interface IPlayerSettings {
	hudHelpButtonsVisible: boolean;
	techTuningDragHintShowed: boolean;
}

export interface IDeathScreenSession {
	sequenceId: number;
	killerNickname: string | null;
	durationMs: number;
}
